<div *ngIf="!loader" class="col-12 col-md-12 col-lg-12 col-xl-12 pl-0 vh-100">
    <ng-scrollbar #scrollable track="all">
        <div class="row content">
            <div class="col-xs-12 ml-4 mt-1 full-width">
                <h1 class="bold">Backlog</h1>
            </div>

            <div class="container-fluid">
                <div class="col-12  mb-3" [ngClass]="{'col-sm-12':!taskPreview,'col-md-12':!taskPreview,'col-lg-12':!taskPreview,'col-xl-12':!taskPreview,
'col-sm-8':taskPreview,'col-md-7':taskPreview,'col-lg-8':taskPreview,'col-xl-8':taskPreview
}" class="vh-100" id="backlogList" #backlogList>


                    <div class="row mr-0 ml-1" *ngFor="let sprint of sprints; index as i">

                        <div

                                class="row mt-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 pointer"
                                style="min-height: 70px">
                            <div class="px-0 d-flex col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="col-5 col-sm-5 col-md-6 col-lg-6 col-xl-6 px-0">
                                    <div class="d-inline container kanban-header kanban-header-purple d-inline font-weight-bold text-uppercase">
                                        {{sprint.name}}
                                        <span *ngIf="sprint.status==='closed'"
                                              class="badge badge-success b-closed-status">zatvoren</span>

                                        <span class="backlog-list-head-details ml-2">
                    {{sprint.tasks.length}} zadataka </span>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-7 col-md-6 col-lg-6 col-xl-6 ">
                                    <button *ngIf="sprint.status=='inactive'"
                                            class="btn btn-primary btn-sm ml-2 b-new-sprint-button float-right"
                                            type="button"
                                            (click)="activateSprint(i)"
                                            [disabled]="isAdmin===false"
                                    >
                                        Pokreni sprint
                                    </button>
                                    <button [disabled]="isAdmin===false"
                                            [matMenuTriggerFor]="sprintOptions"
                                            class="btn btn-primary btn-sm b-new-sprint-button float-right"
                                            type="button">
                                        ...

                                    </button>
                                    <mat-menu #sprintOptions="matMenu">
                                        <button (click)="openSprintModal(sprint.id)" mat-menu-item>
                                            <mat-icon>edit</mat-icon>
                                            Izmijeni sprint
                                        </button>
                                        <button (click)="deleteSprint(sprint.id)" mat-menu-item>
                                            <mat-icon>delete</mat-icon>
                                            Izbriši sprint
                                        </button>
                                    </mat-menu>


                                </div>
                            </div>


                            <div [cdkDropListDisabled]="sprint.status =='closed'" *ngIf="sprint.tasks.length>0"
                                 class="full-width mt-2 cdk-drop-list"
                                 cdkDropList
                                 [id]="sprint.id"
                                 [cdkDropListData]="sprint.tasks"
                                 [cdkDropListConnectedTo]="trackIds"
                                 (cdkDropListDropped)="onTalkDrop($event)">
                                <div class="row mx-2">
                                    <div cdkDrag
                                         [ngClass]="{'mt-0':i===0}"
                                         [cdkDragDisabled]="task.track==='ddone' || task['sort']==='subtask'"
                                         class="mt-2 d-flex align-items-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-sm-3 pr-md-3  backlog-list-card"
                                         *ngFor="let task of sprint.tasks; index as i">

                                        <div class="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 pl-1 py-1 font-weight-500 cursor"
                                             (click)="taskPreviewHandler(task._id, task.sort)">
                                            {{task.title}}
                                        </div>

                                        <div class="col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2 clearfix"></div>

                                        <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4 text-right full-width d-inline-flex px-0">
                                            <div style="width: 30%"></div>

                                            <div style="width: 10%" class="text-center">
                                                <div class="d-inline-flex" id="priority">
<span><i
        [ngStyle]="{'color':task.priority==='high'? 'red':task.priority==='medium'? '#FFAB00':'#5499e0'}"
        class="fa fa-bookmark"></i></span>
                                                </div>
                                            </div>
                                            <div style="width: 10%" class="text-center">
                                                <div class="d-inline-flex align-bottom">
                                                    <app-avatar [avatarWidth]="task.type==='meeting'? 20:23"
                                                                *ngFor="let assign of task.assigned"
                                                                [assigned]="assign"></app-avatar>

                                                </div>
                                            </div>
                                            <div style="width: 15%" class="text-center">
                                                <div class="d-inline-flex">
<span
        title="{{task.comments!==0? 'Ukupan broj komentara na zadatku: '+ task.comments: 'Nema komentara.'}}">
{{task.comments == 0 ? '' : task.comments}}
    <img style="width: 23px" src="assets/icons/comments.png">
</span>

                                                </div>
                                            </div>
                                            <div style="width: 10%">
                                                <div class="d-inline">
                                                    <button (click)="task.visibility=true;storyPoint_2=task.story_points"
                                                            type="button"
                                                            [ngStyle]="{'visibility':task.visibility===null ||task.visibility===undefined?'visible':'hidden',
                                            'margin-left':task.visibility===null ||task.visibility===undefined?'':'-94px'}"
                                                            class="b-points-badge"
                                                            #menuTrigger="matMenuTrigger"
                                                            [matMenuTriggerFor]="menu"
                                                    >
                                                        {{task.story_points}}
                                                    </button>
                                                    <input *ngIf="task.visibility===true"
                                                           [(ngModel)]="storyPoint_2"
                                                           type="number"
                                                           (mouseleave)="task.visibility=null"
                                                           (keypress)="setStoryPointSprintTask($event, sprint.id, i)"
                                                           min="0"
                                                           class="b-points-input">
                                                    <mat-menu (closed)="flag = false"
                                                              [overlapTrigger]="'false'"
                                                              #menu="matMenu">
                                                        <div (click)="$event.preventDefault()"
                                                             class="b-menu-story-points">
                                                            <div class="d-inline-block" style="padding: 7px 2px;">

                                                                <button [value]="button"
                                                                        (click)="storyPoint_2=button;task.visibility=null;setStoryPoint(task)"
                                                                        *ngFor="let button of buttons"
                                                                        class="b-button-options mr-1">{{button}}
                                                                </button>


                                                            </div>

                                                        </div>
                                                    </mat-menu>
                                                </div>
                                            </div>
                                            <div style="width:25% " class="text-center">
                                                <span class="status-button-badge"
                                                      [ngStyle]="{'background': task.status==='ddone' || task.status==='validated'? '#2fd22f': task.status==='todo'? '#52afff':'#c8c8c8'}">{{task.statusName}}</span>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div *ngIf="sprint.tasks.length==0"
                                 class="full-width mt-2 cdk-drop-list b-empty-sprint m-2"
                                 cdkDropList
                                 [id]="sprint.id"
                                 [cdkDropListData]="sprint.tasks"
                                 [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)">


                            </div>


                        </div>
                        <div *ngIf="sprint.status !=='closed'" class="d-inline-block">
                            <button class="new-task-button btn btn-primary mt-2  btn-sm" type="button"
                                    (click)="addNewTaskToSprint(sprint.id)">+ Dodaj zadatak
                            </button>

                        </div>
                    </div>
                    <div class="row mr-0 ml-1">

                        <div class="row mt-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 pointer"

                             style="min-height: 70px">
                            <div class="px-0 d-flex col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="col-12 px-0">
                                    <div class="d-inline container kanban-header kanban-header-purple d-inline font-weight-bold text-uppercase">
                                        {{backlog.id}}

                                        <span class="backlog-list-head-details ml-2">
 {{backlog.tasks.length}}
                                            zadataka </span>
                                    </div>
                                    <div cdkDrag [cdkDragDisabled]="'true'" class="d-inline float-right mr-3">
                                        <button [disabled]="isAdmin===false" (click)="createNewSprint()"
                                                class="btn btn-primary btn-sm b-new-sprint-button"
                                                type="button">
                                            Napravi sprint
                                        </button>
                                    </div>
                                </div>
                            </div>


                            <div
                                    class="full-width mt-2 cdk-drop-list"
                                    cdkDropList
                                    *ngIf="backlog.tasks.length>0"
                                    [id]="backlog.id"
                                    [cdkDropListData]="backlog.tasks"
                                    [cdkDropListConnectedTo]="trackIds"
                                    (cdkDropListDropped)="onTalkDrop($event)">
                                <div class="row mx-2">
                                    <div cdkDrag
                                         [cdkDragDisabled]="task['sort']==='subtask'"
                                         [ngClass]="{'mt-0':i===0}"
                                         class="mt-2 d-flex align-items-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-sm-3 pr-md-3  backlog-list-card"
                                         *ngFor="let task of backlog.tasks; index as i">

                                        <div class="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 pl-1 py-1 font-weight-500 cursor"
                                             (click)="taskPreviewHandler(task._id, task.sort)">
                                            {{task.title}}
                                        </div>

                                        <div class="col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2 clearfix"></div>

                                        <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4 text-right full-width d-inline-flex px-0">
                                            <div style="width:30% ">
                                            </div>
                                            <div style="width:10% " class="text-center">
                                                <div class="d-inline-flex" id="priority">
                                            <span><i
                                                    [ngStyle]="{'color':task.priority==='high'? 'red':task.priority==='medium'? '#FFAB00':'#5499e0'}"
                                                    class="fa fa-bookmark"></i></span>
                                                </div>
                                            </div>
                                            <div style="width:10% " class="text-center">
                                                <div class="d-inline-flex align-bottom">
                                                    <app-avatar [avatarWidth]="task.type==='meeting'? 20:23"
                                                                *ngFor="let assign of task.assigned"
                                                                [assigned]="assign"></app-avatar>

                                                </div>
                                            </div>
                                            <div style="width:15% " class="text-center">
                                                <div class="d-inline-flex">
                                            <span class="ml-2"
                                                  title="{{task.comments!==0? 'Ukupan broj komentara na zadatku: '+ task.comments: 'Nema komentara.'}}">
                                            {{task.comments == 0 ? '' : task.comments}}
                                                <img style="width: 23px" src="assets/icons/comments.png">
                                            </span>

                                                </div>
                                            </div>
                                            <div style="width:10%">
                                                <div class="d-inline">
                                                    <button (click)="task.visibility=true;storyPoint_2=task.story_points"
                                                            type="button"
                                                            [ngStyle]="{'visibility':task.visibility===null ||task.visibility===undefined?'visible':'hidden',
                                            'margin-left':task.visibility===null ||task.visibility===undefined?'':'-94px'}"
                                                            class="b-points-badge"
                                                            #menuTrigger="matMenuTrigger"
                                                            [matMenuTriggerFor]="menu"
                                                    >
                                                        {{task.story_points}}
                                                    </button>
                                                    <input *ngIf="task.visibility===true"
                                                           [(ngModel)]="storyPoint_2"
                                                           type="text" pattern="\d*" [maxlength]="3"
                                                           (mouseleave)="task.visibility=null"
                                                           (keypress)="setStoryPointSprintTask($event, 'backlog', i)"
                                                           min="0"
                                                           class="b-points-input">
                                                    <mat-menu (closed)="flag = false"
                                                              [overlapTrigger]="'false'"
                                                              #menu="matMenu">
                                                        <div (click)="$event.preventDefault()"
                                                             class="b-menu-story-points">
                                                            <div class="d-inline-block" style="padding: 7px 2px;">

                                                                <button [value]="button"
                                                                        (click)="storyPoint_2=button;task.visibility=null;setStoryPoint(task)"
                                                                        *ngFor="let button of buttons"
                                                                        class="b-button-options mr-1">{{button}}
                                                                </button>


                                                            </div>

                                                        </div>
                                                    </mat-menu>
                                                </div>
                                            </div>
                                            <div style="width:25% " class="text-center">
                                                <span class="status-button-badge"
                                                      [ngStyle]="{'background': task.status==='ddone' || task.status==='validated' ? '#2fd22f': task.status==='todo'? '#52afff':'#c8c8c8'}">{{task.statusName}}</span>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div *ngIf="backlog.tasks.length==0"
                                 class="full-width mt-2 cdk-drop-list b-empty-sprint-backlog"
                                 cdkDropList
                                 [id]="backlog.id"
                                 [cdkDropListData]="backlog.tasks"
                                 [cdkDropListConnectedTo]="trackIds"
                                 (cdkDropListDropped)="onTalkDrop($event)">
                            </div>


                        </div>
                        <div class="d-inline-block">
                            <button class="new-task-button btn btn-primary mt-2  btn-sm" type="button"
                                    (click)="addNewTaskToBacklog()">+ Dodaj zadatak
                            </button>

                        </div>
                    </div>


                </div>
                <div *ngIf="taskPreview==true" class="col-12 col-sm-4 col-md-5 col-lg-4 col-xl-4 mt-3 mb-3 vh-100">

                    <app-backlog-task-preview [taskId]="openedTaskId"
                                              [sort]="openedTaskSort"
                                              (closedPreview)="closeTaskPreviewHandler($event)"
                                              (sprintChanged)="onSprintChanged($event)"
                    >
                    </app-backlog-task-preview>


                </div>
            </div>

        </div>


    </ng-scrollbar>


</div>

